'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartLineOutline = function TiChartLineOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 28.3c-1.1 0-2.2-0.4-3.1-1.1-1.1-0.8-1.7-2-1.9-3.3-0.1-1.3 0.3-2.6 1.1-3.7l6.7-8.3c1.6-2.1 4.8-2.5 6.9-0.9l2.8 2.1 3.6-4.6c1-1.2 2.4-1.8 3.9-1.8 1.1 0 2.2 0.4 3.1 1.1 1.1 0.8 1.7 2 1.9 3.3s-0.3 2.7-1.1 3.7l-6.7 8.3c-1.6 2.1-4.8 2.5-6.9 0.9l-2.8-2.1-3.6 4.6c-1 1.1-2.4 1.8-3.9 1.8z m6.7-15c-0.5 0-1 0.3-1.3 0.7l-6.7 8.3c-0.3 0.3-0.4 0.8-0.4 1.2 0.1 0.5 0.3 0.9 0.7 1.1 0.3 0.3 0.7 0.4 1 0.4 0.5 0 1-0.2 1.3-0.6l5.7-7.1 5.3 4c0.7 0.6 1.8 0.4 2.3-0.3l6.7-8.3c0.3-0.3 0.4-0.8 0.4-1.2-0.1-0.5-0.3-0.9-0.7-1.1-0.3-0.3-0.7-0.4-1-0.4-0.5 0-1 0.2-1.3 0.6l-5.7 7.1-5.3-4c-0.3-0.3-0.7-0.4-1-0.4z m15 21.7h-23.4c-0.9 0-1.6-0.7-1.6-1.7s0.7-1.6 1.6-1.6h23.4c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7z' })
        )
    );
};

exports.default = TiChartLineOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-line-outline.js
// module id = 3577
// module chunks = 0